import { Box, Button, Card, Container, Flex, Group, Text, Title } from "@mantine/core";
import { IApp, IProjectDeprecated } from "@mctypes/global.types";
import { IProjectMemberApiItem } from "@schemas/projectSchema";
import React from "react";
import { useHistory } from "react-router-dom";
import AppIcon from "../../../components/AppIcon";
import { getEnabledApps, selectUserMember } from "../../../global/globalSlice";
import { useAppSelector } from "../../../hooks";

const AppsPage: React.FC = () => {
  const project = useAppSelector((state) => state.adminReducer.project);
  const appsToShow = useAppSelector(getEnabledApps);
  const member = useAppSelector(selectUserMember);

  return (
    <Flex h="100%" w="100%">
      <Box className="sidebarOffsetWidth" bg="gray.1" />
      <Box h="100%" p="xl" style={{ flex: 1, overflow: "auto" }}>
        <Container className="lightContrastBackground" p="lg">
          <Box pb="sm" mb="xl" mr="xl" style={{ borderBottom: "3px solid #d5d5d5" }}>
            <Title order={3} c="#404040" fw={500}>
              Appoversikt
            </Title>
          </Box>
          <Group gap="md">
            {appsToShow.map((app) => (
              <AppCard key={app.name} app={app} project={project} member={member} />
            ))}
          </Group>
        </Container>
      </Box>
    </Flex>
  );
};

export default AppsPage;

const AppCard: React.FC<{ app: IApp; project: IProjectDeprecated; member: IProjectMemberApiItem }> = ({
  app,
  project,
  member,
}) => {
  const history = useHistory();

  const goToApp = () => {
    history.push(`/project/${project._id}/${app.name}`);
  };

  return (
    <Card
      shadow="sm"
      padding="0"
      radius="md"
      bd="1px solid var(--mantine-color-warmgray-2)"
      style={{ display: "flex", flexDirection: "column", width: "246px" }}
    >
      <Card.Section>
        <Group
          align="center"
          gap="xs"
          py="2px"
          px={"sm"}
          pos="relative"
          wrap="nowrap"
          bg="warmgray.1"
          style={{ borderBottom: "2px solid var(--mantine-color-warmgray-2)" }}
        >
          <Box
            className="appCardTint"
            bg={app.iconColor === "#f5a346" ? "mc-primary" : app.iconColor}
            pos="absolute"
            top={0}
            left={0}
          />
          <AppIcon app={app} variation="appcard" />
          <Text fw={400} size="1.4em" c="#404040">
            {app.label}
          </Text>
        </Group>
      </Card.Section>

      <Card.Section pt="xs" px={"sm"} style={{ flex: 1 }}>
        <Text size="sm" c="#58595b" lh={1.4} style={{ letterSpacing: ".03em", height: "200px" }}>
          {app.description}
        </Text>
      </Card.Section>

      <Card.Section pb={"xs"} px={"xs"}>
        <Group justify="flex-end">
          <Button variant="outline" color="mc-primary" onClick={goToApp} size="sm">
            Start appen
          </Button>
        </Group>
      </Card.Section>
    </Card>
  );
};
